import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sba-conditions-of-use',
  templateUrl: './conditions-of-use.component.html',
  styleUrls: ['./conditions-of-use.component.scss']
})
export class ConditionsOfUseComponent {}
